import {Component} from '@angular/core';
import {RendererContainerComponent} from '../renderer-container/renderer-container.component';
import {MatIcon} from '@angular/material/icon';
import {NgIf} from '@angular/common';
import {WeekdayPipe} from './weekday.pipe';
import {EnumCellRendererComponent} from '../enum-cell-renderer/enum-cell-renderer.component';

@Component({
  selector: 'lib-weekday-cell-renderer',
  standalone: true,
  imports: [
    RendererContainerComponent,
    MatIcon,
    NgIf,
    WeekdayPipe
  ],
  templateUrl: './weekday-cell-renderer.component.html',
  styleUrl: '../custom-cell/custom-cell.component.scss'
})
export class WeekdayCellRendererComponent extends EnumCellRendererComponent {

    getValuesFromRepository(): string[] {
      if (this.params.value?.value) {
          return this.params.value.value.map((v: any) => {
            return (this.params.colDef as any).repository[v];
          });
      } else {
        return [];
      }
  }
}
